import { render, staticRenderFns } from "./GBPhotoAlbumDrop.vue?vue&type=template&id=025e4290&"
import script from "./GBPhotoAlbumDrop.vue?vue&type=script&lang=js&"
export * from "./GBPhotoAlbumDrop.vue?vue&type=script&lang=js&"
import style0 from "./GBPhotoAlbumDrop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports